import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { POPUP } from '../../../core/properties/application.properties';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class PopupComponent {
  @ViewChild('confirmation') confirmation!: TemplateRef<ElementRef>;
  @ViewChild('information') information!: TemplateRef<ElementRef>;

  @Input() messages!: string[];
  @Input() contentTitle!: string;

  @Output() modalClosed = new EventEmitter<void>();

  template!: TemplateRef<ElementRef>;

  constructor(private activeModal: NgbActiveModal) {}

  /** select the requested popup */
  openModal(type: string) {
    if (type === POPUP.TYPES.CONFIRMATION) {
      setTimeout(() => {
        this.template = this.confirmation;
      }, 0);
    }
    if (type === POPUP.TYPES.INFORMATION) {
      setTimeout(() => {
        this.template = this.information;
      }, 0);
    }
  }
  /** take the positive action message */
  action(actionMessage: string) {
    this.activeModal.close(actionMessage);
  }

  /** close modal from close button or negative action */
  closeModal() {
    this.activeModal.close();
    this.modalClosed.emit(); // Emit event when modal is closed
  }
}
